import { setupDependencies, initDependencies } from './dependencies';

setupDependencies();
initDependencies();

const { runApp } = require('./services/runApp');
runApp();
